export default __webpack_public_path__ + "static/media/defaultBcg.ee614e6e.jpeg";